import React, { Suspense } from "react";
import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "./components/context/UserContext";

import AffiliateDashboard from "./components/Dashboard/Affiliate/Affiliate";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import CreateCourse from "./components/CreateCourse/CreateCourse";

// Affiliate Dashboard
import AffiliateMarketPlace from "./components/Dashboard/MarketPlace/MarketPlace";
import Sales from "./components/Dashboard/Sales/Sales";
import Payouts from "./components/Dashboard/Payouts/Payouts";
import Referrals from "./components/Dashboard/Referral/Referral";
import Settings from "./components/Dashboard/Settings/Settings";
import Loader from "./components/Loader/Loader";

import StudentSignup from "./components/Signup/Student/Student";

// pages
const Landing = React.lazy(() => import("./pages/landing/Landing"));
const Affiliate = React.lazy(() => import("./pages/affiliate/Affiliate"));
const Vendor = React.lazy(() => import("./pages/vendor/Vendor"));
const GetStarted = React.lazy(() => import("./pages/getstarted/GetStarted"));

// affiliate
const AffiliateSignup = React.lazy(() =>
 import("./components/Signup/Affiliate/Affiliate")
);
const AffiliateLogin = React.lazy(() =>
 import("./components/Login/Affiliate/Affiliate")
);
const ConfirmEmail = React.lazy(() =>
 import("./components/Login/ConfirmEmail/ConfirmEmail")
);
const RequestNewPassword = React.lazy(() =>
 import("./components/Login/RequestNewPassword/RequestNewPassword")
);
const ResetPassword = React.lazy(() =>
 import("./components/Login/ResetPassword/ResetPassword")
);

const App = () => {
 const { user } = useContext(UserContext);
 console.log(user);

 return (
  <Routes>
   <Route
    path="/"
    exact
    element={
     <Suspense fallback={<Loader />}>
      <Landing />
     </Suspense>
    }
   />

   <Route
    path="/get-started"
    element={
     <Suspense fallback={<Loader />}>
      <GetStarted />
     </Suspense>
    }
   />
   <Route
    path="/affiliate"
    element={
     <Suspense fallback={<Loader />}>
      <Affiliate />
     </Suspense>
    }
   />
   <Route
    path="/vendor"
    element={
     <Suspense fallback={<Loader />}>
      <Vendor />
     </Suspense>
    }
   />

   {!user && (
    <>
     <Route
      path="/affiliate/login"
      element={
       <Suspense fallback={<Loader />}>
        <AffiliateLogin />
       </Suspense>
      }
     />
     <Route
      path="/affiliate/signup"
      element={
       <Suspense fallback={<Loader />}>
        <AffiliateSignup />
       </Suspense>
      }
     />
     <Route
      path="/student/signup"
      element={
       <Suspense fallback={<Loader />}>
        <StudentSignup />
       </Suspense>
      }
     />
     <Route
      path="/request-new-password"
      element={
       <Suspense fallback={<Loader />}>
        <RequestNewPassword />
       </Suspense>
      }
     />
     <Route
      path="/change-password/:id/:token"
      element={
       <Suspense fallback={<Loader />}>
        <ResetPassword />
       </Suspense>
      }
     />

     <Route path="/affiliate/*" element={<AffiliateLogin />} />
     <Route
      path="/verify-account/:id/:token"
      element={
       <Suspense fallback={<Loader />}>
        <ConfirmEmail />
       </Suspense>
      }
     />
    </>
   )}

   {user && user?.role === "affiliate" && (
    <>
     <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
     <Route
      path="/affiliate/dashboard/products"
      element={<AffiliateMarketPlace />}
     />
     <Route path="/affiliate/dashboard/sales" element={<Sales />} />
     <Route path="/affiliate/dashboard/payouts" element={<Payouts />} />
     <Route path="/affiliate/dashboard/referral" element={<Referrals />} />
     <Route path="/affiliate/dashboard/settings" element={<Settings />} />
     <Route path="/affiliate/dashboard/*" element={<AffiliateDashboard />} />
    </>
   )}

   {user && user?.role === "admin" && (
    <>
     <Route path="/dashboard" element={<AdminDashboard />} />
    </>
   )}

   {user && user?.role === "admin" && (
    <>
     <Route path="/create-course" element={<CreateCourse />} />
    </>
   )}

   <Route
    path="/affiliate/dashboard/*"
    element={
     <Navigate to={user ? "/affiliate/dashboard" : "/affiliate/login"} />
    }
   />

   <Route
    path="*"
    element={<Navigate to={user ? "/affiliate/dashboard" : "/"} />}
   />
  </Routes>
 );
};

export default App;
